import { null as zNull } from "zod/v4";

export const disconnectBlueCherryIntegration = {
  name: "disconnectBlueCherryIntegration" as const,
  input: zNull(),
  output: zNull(),
};
